import React, { useEffect, useState } from 'react'
import type { BomSummary as BomSummaryType } from '@ztechapps/product.common'
import { summarizeBom } from '@ztechapps/product.common'
import { useBillOfMaterialsContext } from './Context'
import { BomProductWidget } from './BomProductWidget'
import type { Product } from '@ztechapps/common.contract'
import { HorizontalStack } from '@ztechapps/webui.util'
import { PurchaseButton } from './purchase-button/PurchaseButton'
import { Stack } from 'react-bootstrap'
import sortBy from 'lodash/sortBy'
import { Table } from '@ztechapps/webui.data-tools'
import { QuantityWithUom } from '../QuantityWithUom'
import { AdjustmentButton } from './adjustment-button/AdjustmentButton'
import { BuildButton } from './build-button/BuildButton'

export const BomSummary = () => {
  const [bomSummaries, setBomSummaries] = useState<BomSummaryType[]>([])
  const { product } = useBillOfMaterialsContext()
  const billOfMaterials = product?.billOfMaterials
  const productId = product?._id

  useEffect(() => {
    const _bomSummaries = summarizeBom(billOfMaterials)

    //convert this to array
    const bomSummaryArray = Array.from(_bomSummaries.values())

    //sort by product code
    const sortedBomSummaryArray = sortBy(bomSummaryArray, (b) => b.product.code)

    setBomSummaries(sortedBomSummaryArray)
  }, [productId, billOfMaterials])

  return (
    <Stack>
      <Table
        emptyContent={
          <div>
            <h3 className="text-success">Enough inventory to build this product.</h3>
            <p>It will show up here the products that are needed to purchase or build if there not enough inventory.</p>
          </div>
        }
        tableClassName="table table-hover"
        dataArray={bomSummaries}
        head={
          <thead>
            <tr className="table-secondary">
              <th style={{ width: '60%' }}>Product</th>
              <th className="text-end">Total Qty. Needed</th>
              <th className="text-end">Action</th>
            </tr>
          </thead>
        }
        row={(bomSummary) => {
          const bomProduct = (bomSummary?.product ?? {}) as Product
          return (
            <tr key={bomProduct._id}>
              <td>
                <BomProductWidget {...bomProduct} />
              </td>
              <td className="text-end">
                <QuantityWithUom
                  quantity={bomSummary.qtyNeededToBuild}
                  symbol={bomProduct?.workOrderUom?.symbol}
                  decimalPrecision={bomProduct?.unitOfMeasurePrecision ?? 0}
                />
              </td>
              <td className="text-end">
                <HorizontalStack gap={1} className="justify-content-end">
                  <BuildButton {...(bomSummary as BomSummaryType)} />
                  <PurchaseButton {...(bomSummary as BomSummaryType)} />
                  <AdjustmentButton {...(bomSummary as BomSummaryType)} />
                </HorizontalStack>
              </td>
            </tr>
          )
        }}
      />
    </Stack>
  )
}
